// https://stackoverflow.com/questions/70585815/react-this-props-match-is-undefined
// https://reactrouter.com/docs/en/v6/getting-started/tutorial#reading-url-params
import { Suspense, useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import NotFoundPage from "@pages/404";
import { GetSpecificOrganization } from "@services/client-list.service";
import { getValue } from "@utils/lodash";
import { PrivateRoutes } from "./private.routes";
import { PublicRoutes } from "./public.routes";
import { getAllPermissions } from "@services/roles.service";
import _ from "lodash";
import SSOPage from "@pages/SSO/sso";
import SSOLoginPage from "@pages/SSO/sso-login";
import AuthRefresh from "@pages/Auth/Client/Refresh";

const IndexRoutes = () => {
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const [tabPermissionList, setTabPermissionList] = useState([]);
  const [subTabPermissionList, setSubTabPermissionList] = useState([]);
  const [permissionAPITriggered, setPermissionAPITriggered] = useState(false);
  const [products, setProducts] = useState([]);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    if (getValue(localStorage, `user`, "")) {
      let user = JSON.parse(getValue(localStorage, `user`, ""));
      if (getValue(user, `org_id`, "")) {
        getData(getValue(user, `org_id`, ""));
      }
    }
    let token = localStorage.getItem("accessToken");
    if (token) {
      getPermissions();
    }
  }, []);
  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const covertSecondString = (s: string) => {
    var lastIndex = s.lastIndexOf(":");
    if (lastIndex !== -1) {
      s = s.substring(0, lastIndex) + "-" + s.substring(lastIndex + 1);
    }
    return s;
  };
  const [mainPermissions, setMainPermissions] = useState([]);
  const getPermissions = async () => {
    try {
      let resp = await getAllPermissions();
      if (resp) {
        let response = getValue(resp, `data.permissions`, []).filter(
          (item: any) => {
            if (item) return item;
          }
        );
        let list =
          getValue(response, `length`, 0) > 0
            ? response.map((item: any) => {
                return covertSecondString(item).split("-").length === 2
                  ? covertSecondString(item).split("-")
                  : item.split(":");
              })
            : [];
        let arr: any = [];
        for (let i = 0; i < list.length; i++) {
          arr.push({
            tab: list[i][0],
            permission: list[i][1],
          });
        }
        var groupedPermission =
          getValue(arr, `length`, 0) > 0
            ? _.groupBy(arr, function (item: any) {
                return item.tab;
              })
            : [];
        var ObjectEntry: any = Object.entries(groupedPermission);
        const arr1: any = [];
        for (let i = 0; i < ObjectEntry.length; i++) {
          arr1.push({
            tab: ObjectEntry[i][0].split(":")[0],
            tabKey:
              ObjectEntry[i][0].split(":").length == 2
                ? ObjectEntry[i][0].split(":")[0] +
                  "_" +
                  ObjectEntry[i][0].split(":")[1]
                : ObjectEntry[i][0].split(":").length == 3
                ? ObjectEntry[i][0].split(":")[0] +
                  "_" +
                  ObjectEntry[i][0].split(":")[1] +
                  "_" +
                  ObjectEntry[i][0].split(":")[2]
                : ObjectEntry[i][0].split(":")[0],
            permissions: ObjectEntry[i][1].map((item: any) => item.permission),
          });
        }
        setMainPermissions(arr1);
        setTabPermissionList(_.uniq(arr1.map((item: any) => item.tab)));
        setSubTabPermissionList(_.uniq(arr1.map((item: any) => item.tabKey)));
        setPermissionAPITriggered(true);
        setProducts(getValue(resp, `data.ps`, []));
      } else {
        setPermissionAPITriggered(true);
      }
    } catch (error) {
      setPermissionAPITriggered(true);
    }
  };
  const getData = async (id: string) => {
    try {
      let resp = await GetSpecificOrganization(id);
      if (resp) {
        // document.body.className =
        // document.body.className + ' ' + getValue(resp, 'data.title','');
        document.documentElement.style.setProperty(
          "--primary-color",
          hexToRgbA(getValue(resp, "data.data.primary_color", "#fa6204"))
        );
        document.documentElement.style.setProperty(
          "--secondary-color",
          hexToRgbA(getValue(resp, "data.data.secondary_color", "#0d0d73"))
        );
        document.documentElement.style.setProperty(
          "--color",
          hexToRgbA(getValue(resp, "data.data.text_color", "#ffffff"))
        );
      }
    } catch (error) {}
  };
  /* -------------------------------------------------------------------------- */
  /*                            Helper Section                                  */
  /* -------------------------------------------------------------------------- */
  function hexToRgbA(hex: string) {
    var c: any;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split("");
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = "0x" + c.join("");
      return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",");
      // return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',1)';
    }
    throw new Error("Bad Hex");
  }
  // console.log(subTabPermissionList)
  return (
    <BrowserRouter>
      <Routes>
        {PublicRoutes.map((item, key) => {
          let Element: any = item.component;
          return (
            <Route
              key={key}
              path={item.path}
              element={
                !localStorage.getItem("accessToken") ? (
                  <Element />
                ) : (
                  <Navigate to="/dashboard/self-compliance/compliance" />
                )
              }
            />
          );
        })}
        {PrivateRoutes.map((item: any, key) => {
          let permissions = mainPermissions.filter(
            (items: object) => getValue(items, `tabKey`, "") == item?.name
          );

          let Element: any = item?.component;
          return (
            <Route
              key={key}
              path={item?.path}
              element={
                localStorage.getItem("accessToken") ? (
                  <Element
                    permissions={
                      getValue(permissions, `length`, 0) > 0
                        ? getValue(permissions, `[${0}].permissions`, [])
                        : []
                    }
                    products={products}
                    name={getValue(item, `name`, "")}
                    tabPermissionList={tabPermissionList}
                    permissionAPITriggered={permissionAPITriggered}
                    subTabPermissionList={subTabPermissionList}
                  />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
          );
        })}
        <Route path={"/auth/sso/callback"} element={<SSOPage />} />
        <Route path={"/auth/login/sso"} element={<SSOLoginPage />} />
        <Route path={"/login/refesh"} element={<AuthRefresh />} />
        <Route path={"*"} element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default IndexRoutes;
